export enum HIGHEST_LEVEL_EDUCATION {
	BACHELORS_DEGREE = 881840005
}
